import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess404002Status: 'idle',
    startProcess404002Error: undefined as any,
    loadUserParamsProcess404002Status: 'idle',
    loadUserParamsProcess404002Error: undefined as any,

    process404002List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess404002 = createAsyncThunk('process404002Slice/startProcess404002', async ({ process404002 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess404002/`,
        prepareData(process404002),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess404002Status } = getState().process404002Slice
        return startProcess404002Status !== 'pending'
    }
})

export const loadUserParamsProcess404002 = createAsyncThunk('process404002Slice/loadUserParamsProcess404002', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess404002/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess404002Status } = getState().process404002Slice
        return loadUserParamsProcess404002Status !== 'pending'
    }
})

const Process404002Slice = createSlice({
    name: 'process404002Slice',
    initialState,
    reducers: {
        resetstartProcess404002: (state) => {
            state.job = undefined
            state.startProcess404002Error = undefined
        },
        resetstartProcess404002Error: (state) => {
            state.startProcess404002Error = undefined
        },
        resetloadUserParamsProcess404002: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess404002Error = undefined
        },
        resetloadUserParamsProcess404002Error: (state) => {
            state.loadUserParamsProcess404002Error = undefined
        },
        removeFromProcess404002ListById: (state, action) => {
            state.process404002List = state.process404002List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess404002ListByIds: (state, action) => {
            state.process404002List = state.process404002List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process404002List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess404002Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process404002List = []
            state.startProcess404002Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess404002.pending, (state) => {
            state.startProcess404002Status = 'pending'
            state.startProcess404002Error = undefined
        })
        builder.addCase(startProcess404002.fulfilled, (state, action) => {
            state.startProcess404002Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess404002.rejected, (state, action) => {
            state.startProcess404002Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess404002Error = action.error.message
            } else {
                state.startProcess404002Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess404002.pending, (state) => {
            state.loadUserParamsProcess404002Status = 'pending'
            state.loadUserParamsProcess404002Error = undefined
        })
        builder.addCase(loadUserParamsProcess404002.fulfilled, (state, action) => {
            state.loadUserParamsProcess404002Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess404002.rejected, (state, action) => {
            state.loadUserParamsProcess404002Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess404002Error = action.error.message
            } else {
                state.loadUserParamsProcess404002Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess404002,
    resetstartProcess404002Error,
    resetloadUserParamsProcess404002,
    resetloadUserParamsProcess404002Error,
    removeFromProcess404002ListById,
    removeFromProcess404002ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process404002Slice.actions
export default Process404002Slice.reducer
